export interface SnackBarModel {
  type: SNACKBAR_CLASS;
  message: string;
}

export enum SNACKBAR_CLASS {
  WARNING_CLASS = "rfc-warning",
  INFO_CLASS = "rfc-info",
  ERROR_CLASS = "rfc-danger",
  SUCCESS_CLASS = "rfc-success",
}
